import React, { Component } from 'react';

import BigCalendar from 'react-big-calendar';
import moment from 'moment';

import ArrowDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Popover from 'material-ui/Popover';
import RaisedButton from 'material-ui/RaisedButton';

import CalendarPicker from './CalendarPicker';
import EventDetail from './EventDetail';
import GoogleCalendar from '../../../services/google-calendar';
import * as ParseService from '../../../services/parse';

import 'react-big-calendar/lib/css/react-big-calendar.css'
import '../styles/planner.css'

BigCalendar.setLocalizer(
  BigCalendar.momentLocalizer(moment)
);

const calendarViews = [
  'month',
  'week'
];

const calendarFormats = {
  dateFormat: 'D', 
  dayFormat: 'ddd M/D', 
  timeGutterFormat: 'ha',
};

const navigationStyles = {
  smallIcon: {
    width: 18,
    height: 18,
    color: '#3498db',
  },
  small: {
    width: 32,
    height: 32,
    padding: 6,
  },
  tooltip: {
    left: -2,
    top: 24,
  }
};

const smallFlatButtonStyles = {
  height: '30px', 
  lineHeight: '30px', 
  minWidth: '70px',
};

const smallFlatButtonLabelStyles = {
  fontSize: '13px',
};

class PlannerCalendarToolbar extends Component {

  constructor(props) {
    super(props);

    this.state = {
      viewsAnchorEl: null,
    }

    this.handleOpenViewMenu = this.handleOpenViewMenu.bind(this);
    this.handleViewChange = this.handleViewChange.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
  }

  handleOpenViewMenu(e) {
    this.setState({
      viewsAnchorEl: e.currentTarget
    });
  }

  handleViewChange(e, value) {
    this.setState({
      viewsAnchorEl: null
    });

    this.props.onViewChange(value);
  }

  handleRequestClose() {
    this.setState({
      viewsAnchorEl: null
    });
  };
  
  render() {
    return (
      <div className='calendar__toolbar'>
        
        <FlatButton
          style={smallFlatButtonStyles}
          label="Today"
          labelStyle={smallFlatButtonLabelStyles}
          onClick={this.props.onToday}
          backgroundColor='rgb(248, 248, 248)'
          secondary={true}
        />

        <IconButton
          onClick={this.props.onPreviousPeriod}
          iconStyle={navigationStyles.smallIcon}
          style={navigationStyles.small}
          tooltip="Previous"
          tooltipStyles={navigationStyles.tooltip}
          >
          <ChevronLeft />
        </IconButton>
          
        <IconButton
          onClick={this.props.onNextPeriod}
          iconStyle={navigationStyles.smallIcon}
          style={navigationStyles.small}
          tooltip="Next"
          tooltipStyles={navigationStyles.tooltip}>
          <ChevronRight />
        </IconButton>

        <h3 className='calendar__toolbar__title'>
          {moment(this.props.date).format('MMMM')} {moment(this.props.date).format('YYYY')}
        </h3>

        <FlatButton
          style={smallFlatButtonStyles}
          label={this.props.view}
          labelPosition="before"
          labelStyle={smallFlatButtonLabelStyles}
          onClick={this.handleOpenViewMenu}
          backgroundColor='rgb(248, 248, 248)'
          secondary={true}
          icon={ <ArrowDown /> }
        />

        <Popover
          open={this.state.viewsAnchorEl !== null}
          anchorEl={this.state.viewsAnchorEl}
          anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'left', vertical: 'top'}}
          onRequestClose={this.handleRequestClose}>

          <Menu 
            desktop={true}
            value={this.props.view}
            onChange={this.handleViewChange}>

            {calendarViews.map((view) => {
              return (
                <MenuItem
                primaryText={view.charAt(0).toUpperCase() + view.slice(1)} 
                value={view} />  
              )
            })}
          </Menu>

        </Popover>

        <RaisedButton
          label="Calendars"
          secondary={true}
          onClick={this.props.onCalendarsClick}
          style={{height: '30px', marginLeft: '12px'}}
          buttonStyle={{lineHeight: '30px'}} />

      </div>
    );
  }
  
}

function EventDetailDialog(props) {
  const actions = [
    <FlatButton
      label="Done"
      primary={true}
      onClick={props.onClose} />
  ];

  return (
    <Dialog
      open={true}
      onRequestClose={props.onClose}
      actions={actions}
      contentStyle={{width: '320px'}} >
    
      <EventDetail calendarEvent={props.calendarEvent} />
    
    </Dialog>
  );
}

class PlannerCalendar extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedDate: new Date(),
      calendarView: props.defaultView,
      isCalendarsOpen: false,
      events: [],
      calendars: [],
    };

    this.handleToday = this.handleToday.bind(this);
    this.handleNextPeriod = this.handleNextPeriod.bind(this);
    this.handlePreviousPeriod = this.handlePreviousPeriod.bind(this);
    this.handleViewChange = this.handleViewChange.bind(this);
  }

  componentDidMount() {
    this.findCalendars();
  }

  findCalendars() {
    const that = this;

    ParseService.findCalendarInfos({
      success: function(calendarInfos) {
        that.setState({calendars: calendarInfos, events: []});
        that.listEvents();
      },
      error: function(err) {
        console.log("Error finding calendar infos " + err);
      }
    });  
  }

  listEvents() {
    const that = this;

    const mDate = moment(this.state.selectedDate);
    const start = mDate.startOf(this.state.calendarView).toDate();
    const end = mDate.endOf(this.state.calendarView).toDate();

    const calendars = this.state.calendars;
    if (calendars.length > 0) {
      calendars.forEach((calendar, index) => {
        GoogleCalendar.listEvents(calendar.get('calendarId'), start, end, {
          success: function(events) {
            var oldEvents = that.state.events;
            that.setState({events: oldEvents.concat(events)});
          },
          error: function(err) {
            console.log("Error listing events " + err);
          }
        });
      });
    } else {
      this.setState({events: []});
    }
  }

  handleCalendarAdd = (calendarInfo) => {
    const calendars = this.state.calendars;
    calendars.push(calendarInfo);

    this.setState({calendars: calendars, events: []});
    this.listEvents();
  }

  handleCalendarDelete = (calendarInfo) => {
    this.findCalendars();
  }

  handleToday() {
    const date = new Date();
    this.setState({selectedDate: date});

    this.props.onChange(date, this.state.calendarView);
  }

  handleNextPeriod() {
    const period = this.state.calendarView === 'month' ? 'months' : 'weeks';

    const oldDate = this.state.selectedDate;
    const newDate = moment(oldDate).add(1, period).toDate();

    this.setState({selectedDate: newDate});

    this.props.onChange(newDate, this.state.calendarView);
  }

  handlePreviousPeriod() {
    const period = this.state.calendarView === 'month' ? 'months' : 'weeks';

    const oldDate = this.state.selectedDate;
    const newDate = moment(oldDate).subtract(1, period).toDate();

    this.setState({selectedDate: newDate});

    this.props.onChange(newDate, this.state.calendarView);
  }

  handleViewChange(view) {
    this.setState({calendarView: view});

    this.props.onChange(this.state.selectedDate, view);
  }
  
  render() {

    const isCalendarsOpen = this.state.isCalendarsOpen;
    const calendarPicker = isCalendarsOpen ? (
                            <CalendarPicker 
                              onCalendarAdd={this.handleCalendarAdd} 
                              onCalendarDelete={this.handleCalendarDelete} 
                              calendars={this.state.calendars} 
                              onClose={() => this.setState({isCalendarsOpen: false})} /> 
                            ) : null;

    const event = this.state.selectedEvent;
    const eventDetail = event != null ? (
      <EventDetailDialog 
        onClose={() => this.setState({selectedEvent: null})}
        calendarEvent={event} />
      ) : null;
    
    return (
      <div className='calendar'>
        <PlannerCalendarToolbar 
          date={this.state.selectedDate}
          onToday={this.handleToday}
          onPreviousPeriod={this.handlePreviousPeriod}
          onNextPeriod={this.handleNextPeriod}
          view={this.state.calendarView}
          onViewChange={this.handleViewChange}
          onCalendarsClick={() => this.setState({isCalendarsOpen: true})} 
        />
        
        <BigCalendar
          views={calendarViews}
          view={this.state.calendarView}
          startAccessor='start'
          endAccessor='end'
          onNavigate={this.onNavigate}
          popup={true}
          toolbar={false}
          date={this.state.selectedDate}
          formats={calendarFormats}
          onView={() => console.log('Changed view.')}
          events={this.state.events}
          selectable={true}
          onSelectEvent={(event) => this.setState({selectedEvent: event})}
        />


        { calendarPicker }
      
        { eventDetail }
      </div>
         
    );
  }
}

export default PlannerCalendar;


// WEBPACK FOOTER //
// ./src/scenes/Planner/components/PlannerCalendar.js